import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Ranting from "../containers/Renting";
import Lending from "../containers/Lending";
import ProductDetail from "../containers/ProductDetail";
import Dashboard from "../containers/Dashboard";
import Search from "../containers/Search";
import SearchByCategory from "../containers/SearchByCategory";
import CheckOut from "../containers/CheckOut";
import WithDraw from "../containers/Withdraw";
import Profile from "../containers/Profile";
import RentalsItems from "../containers/RentalsItems";
import EditProfile from "../containers/EditProfile";
import TermsUse from "../containers/TermsUse";
import PrivacyPolicy from "../containers/PrivacyPolicy";
import Faqs from "../containers/Faqs";
import IdentityVerification from "../containers/Identity";
import Listanitem from "../containers/Listanitem";
import InboxChat from "../containers/Inbox";
import RentalList from "../containers/RentalList";
import NotFound from "../containers/NotFound";
import AuthProvider from "../context/AuthContext";
import GlobalProvider from "../context/GlobalContext";

const StackRoutes = (props) => {
  const [loginData, setLoginData] = useState({});
  useEffect(() => {
    let userData = sessionStorage.getItem("user");
    userData && setLoginData(JSON.parse(userData));
  }, []);

  return (
    <AuthProvider>
      <GlobalProvider>
        {loginData.id ? (
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/CheckOut" element={<CheckOut />} />
            <Route path="/WithDraw" element={<WithDraw />} />
            <Route path="/Profile" element={<Profile />} />
            <Route path="/RentalsItems" element={<RentalsItems />} />
            <Route path="/EditProfile" element={<EditProfile />} />
            <Route path="/IdentityVerification" element={<IdentityVerification />} />
            <Route path="/Listanitem" element={<Listanitem />} />
            <Route path="/Inbox" element={<InboxChat />} />
            <Route path="/search" element={<Search />} />
            <Route path="/searchbycategory" element={<SearchByCategory />} />
            <Route path="/Renting" element={<Ranting />} />
            <Route path="/Lending" element={<Lending />} />
            <Route path="/ProductDetail" element={<ProductDetail />} />
            <Route path="/termsofuse" element={<TermsUse />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/Faqs" element={<Faqs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/search" element={<Search />} />
            <Route path="/searchbycategory" element={<SearchByCategory />} />
            <Route path="/Renting" element={<Ranting />} />
            <Route path="/Lending" element={<Lending />} />
            <Route path="/ProductDetail" element={<ProductDetail />} />
            <Route path="/termsofuse" element={<TermsUse />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/Faqs" element={<Faqs />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        )}
      </GlobalProvider>
    </AuthProvider>
  );
};

// Routes For Navigation
const MyRoutes = () => (
  <BrowserRouter>
    <StackRoutes />
  </BrowserRouter>
);

export default MyRoutes;
